/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-button/webhook-form-button.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
.button-center {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.workflow-button-label {
  height: 30px;
}
/*# sourceMappingURL=webhook-form-button.component.css.map */
